/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {pendingExportSelector} from '../store/selectors/exporter-selectors';
import {ExportContext} from '../types/redux';

/**
 * Hook for determining the export status of a job status (bulk activity status) request.
 */
export const useExportProgress = (exportContext: ExportContext): boolean => {
  const pending = useSelector(pendingExportSelector);
  return !!pending[exportContext];
};

export default useExportProgress;
